import { MessageAttachment } from '@app/models'
import { scrollToBottom } from '@app/utils'

import type {
  ReplyAttachment,
  ReplyHandleChange,
  ReplyHandleSubmit,
} from './types'

export const handleChange: ReplyHandleChange = (
  conversationId,
  setInputValue
) => {
  return (event) => {
    setInputValue((map) => new Map(map.set(conversationId, event.target.value)))
  }
}

export const handleSubmit: ReplyHandleSubmit = (
  conversationId,
  conversation,
  inputValue,
  setInputValue,
  handleSendMessage,
  attachments,
  setAttachments
) => {
  return (event) => {
    event.preventDefault()

    const messageContent = inputValue.get(conversation.id) ?? ''
    const conversationAttachments = attachments.get(conversationId) ?? []
    const hasAttachments = conversationAttachments.length > 0
    const hasContent = messageContent.trim().length > 0

    if (!hasContent && !hasAttachments) {
      return false
    }

    handleSendMessage(
      messageContent,
      mapReplyAttachments(conversationAttachments)
    )

    setInputValue((map) => new Map(map.set(conversationId, '')))
    setAttachments((map) => {
      const next = new Map(map)
      next.set(conversationId, [])
      return next
    })
    setTimeout(() => {
      scrollToBottom()
    }, 0)

    return true
  }
}

const mapReplyAttachments = (items: ReplyAttachment[]): MessageAttachment[] =>
  items.map((item) => ({ kind: 'Listing', listingId: item.id }))
